import { queryOptions } from "@tanstack/react-query";
import { MAX_SCENE_IMAGES, MAX_SCENE_IMAGE_TRIGGER } from "../scene-image";
import { getAppConfig, getAppConfigMemo, getWebHome } from "../common";

export const AppConfigQueryOption = queryOptions({
  queryKey: ['app', 'config'],
  queryFn: async () => (await getAppConfig()).data
})

export const sceneImageConfigQueryOption = queryOptions({
  queryKey: ["app", "config", "memo", "scene_image"],
  queryFn: async () => {
    const res = await getAppConfigMemo({ group: "scene_image" })
    return res.data
  },
  staleTime: Infinity,
})

const pickConfigNumber = (
  config: Record<string, unknown> | null | undefined,
  keys: string[],
  fallback: number,
) => {
  for (const key of keys) {
    const value = Number(config?.[key])
    if (Number.isFinite(value) && value > 0) return value
  }
  return fallback
}

/** scene_image 组：单张/宫格价格与数量上限 */
export const getSceneImageConfig = (config?: Record<string, unknown> | null) => ({
  single: pickConfigNumber(config, ["price_single"], 9),
  multiple: pickConfigNumber(config, ["price_grid"], 20),
  maxImages: MAX_SCENE_IMAGES,
  maxTriggerChars: Math.min(pickConfigNumber(config, ["max_trigger_chars"], MAX_SCENE_IMAGE_TRIGGER), MAX_SCENE_IMAGE_TRIGGER),
})

export const WebHomeQueryOption = queryOptions({
  queryKey: ['web', 'home'],
  queryFn: async () => (await getWebHome()).data
})